import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoaderService } from './loader-service.service';
import { finalize, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';

@Injectable()
export class LottieLoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: LoaderService, private helperService: HelpersService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const noLoader = request.params.get('noLoader');

    if (noLoader === 'true') {
      return next.handle(request);
    } else {
      if (!this.requests.length) {
        this.loaderService.showLottieLoader();
      }
      this.requests.push(request);

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        }),
        finalize(() => {
          const i = this.requests.indexOf(request);
          if (i >= 0) {
            this.requests.splice(i, 1);
          }
          if (this.requests.length === 0) {
            setTimeout(() => {
              this.loaderService.hideLottieLoader();
            }, 10);
          }
        })
      );
    }
  }
}
